export const PLAYER_COLOR = {
  BLACK: 'black',
  WHITE: 'white',
};
